module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab"
  }, [_c('router-link', {
    staticClass: "tab-item",
    attrs: {
      "tag": "div",
      "to": "/recommend"
    }
  }, [_c('span', {
    staticClass: "tab-link"
  }, [_vm._v("推荐")])]), _vm._v(" "), _c('router-link', {
    staticClass: "tab-item",
    attrs: {
      "tag": "div",
      "to": "/singer"
    }
  }, [_c('span', {
    staticClass: "tab-link"
  }, [_vm._v("歌手")])]), _vm._v(" "), _c('router-link', {
    staticClass: "tab-item",
    attrs: {
      "tag": "div",
      "to": "/rank"
    }
  }, [_c('span', {
    staticClass: "tab-link"
  }, [_vm._v("排行")])]), _vm._v(" "), _c('router-link', {
    staticClass: "tab-item",
    attrs: {
      "tag": "div",
      "to": "/search"
    }
  }, [_c('span', {
    staticClass: "tab-link"
  }, [_vm._v("搜索")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6919f4cc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tab/tab.vue
// module id = 541
// module chunks = 9